import { createAction, props } from '@ngrx/store';
import { ActiveElement } from '../../models/active-element.model';

export const setActiveElement = createAction('[OYAN NAVIGATIONS] Set active element', props<{ activeElement: ActiveElement }>());
